import ArrowLeft from '@/assets/icons/ArrowLeft.svg';
import ArrowRight from '@/assets/icons/ArrowRight.svg';
import ChevronLeft from '@/assets/icons/ChevronLeft.svg';
import ChevronRight from '@/assets/icons/ChevronRight.svg';
import PauseIcon from '@/assets/icons/Pause.svg';
import PlayIcon from '@/assets/icons/Play.svg';
import * as Styled from './CarouselControls.styled';

export const PrevButton = () => (
  <Styled.ControlButton dir="prev" aria-label="Previous">
    <ChevronLeft />
  </Styled.ControlButton>
);

export const NextButton = () => (
  <Styled.ControlButton dir="next" aria-label="Next">
    <ChevronRight />
  </Styled.ControlButton>
);

export const PlayPauseToggle = () => (
  <Styled.PlayPause aria-label="Toggle autoplay">
    {({ autoplayUserPreference }: { autoplayUserPreference: boolean }) =>
      autoplayUserPreference ? <PauseIcon /> : <PlayIcon />
    }
  </Styled.PlayPause>
);

export const FloatingPrevArrow = () => (
  <Styled.FloatingArrow dir="prev" aria-label="Previous" data-direction="prev">
    <ArrowLeft />
  </Styled.FloatingArrow>
);

export const FloatingNextArrow = () => (
  <Styled.FloatingArrow dir="next" aria-label="Next" data-direction="next">
    <ArrowRight />
  </Styled.FloatingArrow>
);

export const ControlsCluster = () => (
  <Styled.Cluster>
    <PlayPauseToggle />
    <PrevButton />
    <NextButton />
  </Styled.Cluster>
);
